import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import dayjs, { Dayjs } from "dayjs"
import { ReactElement } from "react"

import { TEXT_FIELD_DEFAULT_PROPS } from "../../../themes/baseTheme"
import {
    apiDateTimeToDayJs,
    dayJsToStrForDnoApi,
} from "../../../utils/general/generalUtils"

const shortcutsItems = [
    {
        label: "Today",
        getValue: () => dayjs(),
    },
    {
        label: "Start of Week",
        getValue: () => {
            const today = dayjs()
            return today.startOf("week")
        },
    },
    {
        label: "1 Week Ago",
        getValue: () => {
            const today = dayjs()
            return today.subtract(7, "day")
        },
    },
    {
        label: "1 Month Ago",
        getValue: () => {
            const today = dayjs()
            return today.subtract(1, "month")
        },
    },
    {
        label: "3 Months Ago",
        getValue: () => {
            const today = dayjs()
            return today.subtract(2, "month")
        },
    },
    {
        label: "Reset",
        getValue: () => null,
        changeImportance: "accept" as const,
    },
]

interface IDatePickerProps {
    dateValue: string
    setDateValue: (date: string) => void
    label: string
}

/**
 * Generic controlled date picker
 *
 * Note on the onChange function: the onChange function is called whenever the
 * user selects a new date. The function is passed two arguments: the new date
 * and a context object. The context object contains a validation error if the
 * user selects an invalid date or date outside of the specified range. It
 * fires on every change. The value state is updated only if the context object
 * does not contain a validation error. The validation error corresponds
 * with the component error state. Clear events set the value to null. The
 * control value hence is only updated when the date is valid.
 */

const AppControlledDateRange = ({
    label,
    dateValue,
    setDateValue,
}: IDatePickerProps): ReactElement => (
    <DatePicker
        value={apiDateTimeToDayJs(dateValue)}
        onChange={(newValue: Dayjs | null, context) => {
            if (!context.validationError) {
                if (!newValue) setDateValue("")
                else setDateValue(dayJsToStrForDnoApi(newValue))
            }
        }}
        // lotProps={{ textField: { size: "small" } }}
        disableFuture
        label={label}
        format="DD/MM/YYYY"
        slotProps={{
            shortcuts: {
                items: shortcutsItems,
            },
            textField: TEXT_FIELD_DEFAULT_PROPS,
        }}
    />
)

export default AppControlledDateRange
